const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScreenshot(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1280",
    d: "M317.414 366.839h2v-1h1v-2h-3z",
    style: {
      fill: "current"
    },
    transform: "translate(-314.414 -358.839)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1561",
    transform: "translate(8.199 5)",
    style: {
      fill: "current"
    },
    d: "M0 0h4.4v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1562",
    transform: "translate(14.799 5)",
    style: {
      fill: "current"
    },
    d: "M0 0h4.4v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1563",
    transform: "translate(21.399 5)",
    style: {
      fill: "current"
    },
    d: "M0 0h4.399v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1281",
    d: "M343.413 366.839h2v-3h-3v2h1z",
    style: {
      fill: "current"
    },
    transform: "translate(-314.414 -358.839)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1282",
    d: "M319.414 378.84h-2v3h3v-2h-1z",
    style: {
      fill: "current"
    },
    transform: "translate(-314.414 -358.839)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1564",
    transform: "translate(3 14.857)",
    style: {
      fill: "current"
    },
    d: "M0 0h2v3.429H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1565",
    transform: "translate(3 9.715)",
    style: {
      fill: "current"
    },
    d: "M0 0h2v3.428H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1566",
    transform: "translate(28.999 9.715)",
    style: {
      fill: "current"
    },
    d: "M0 0h2v3.429H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 1567",
    transform: "translate(8.2 21.001)",
    style: {
      fill: "current"
    },
    d: "M0 0h4.4v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1283",
    d: "M348.413 377.3a2.76 2.76 0 0 0-2.726-2.792h-.274v-.808h-2v.809h-.638l-1.43-2.21a1 1 0 0 0-.84-.457h-5.183a1 1 0 0 0-.84.457l-1.43 2.21h-2.927a2.754 2.754 0 0 0-2.711 2.778v9.763a2.761 2.761 0 0 0 2.727 2.793H345.7a2.756 2.756 0 0 0 2.711-2.785zm-2 9.764v.014a.754.754 0 0 1-.726.764h-15.531a.756.756 0 0 1-.742-.778v-9.794a.752.752 0 0 1 .727-.764h3.459a1 1 0 0 0 .84-.456l1.43-2.211h4.1l1.431 2.211a1 1 0 0 0 .839.456h3.441a.758.758 0 0 1 .741.778z",
    style: {
      fill: "current"
    },
    transform: "translate(-314.414 -358.839)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1284",
    d: "M337.914 377.231a4.507 4.507 0 1 0 4.508 4.507 4.512 4.512 0 0 0-4.508-4.507zm0 7.014a2.507 2.507 0 1 1 2.508-2.507 2.51 2.51 0 0 1-2.508 2.507z",
    style: {
      fill: "current"
    },
    transform: "translate(-314.414 -358.839)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScreenshot);
export default __webpack_public_path__ + "static/media/icon-screenshot.50e42664c1629d0b1b8c1a2438d6f20e.svg";
export { ForwardRef as ReactComponent };